import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, FormControlLabel, Switch } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import Alert from 'src/shared/Alert/Alert'
import autobind from 'autobind-decorator'
import { updateAccountInfos, fetchAccountInfos } from 'src/core/redux/action/accountInfosAction'

const styles = (t: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  }
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
  activeLabel?: string
  inactiveLabel?: string
}

class MailNotification extends React.Component<IProps, {}> {

  render() {
    const {t, classes, user, activeLabel=t.notification_active_label, inactiveLabel=t.notification_inactive_label} = this.props
    return (
        <Alert type={user.allow_mail_notifications ? "info" : "warning"}>
            <div className={classes.root}>
            {user.allow_mail_notifications ? activeLabel : inactiveLabel}
            <FormControlLabel
                control={
                    <Switch
                        checked={user.allow_mail_notifications}
                        onChange={this.toggleReceiveNotification}
                    />
                }
                label=""
            />
        </div>
        </Alert>
    )
  }

  @autobind
  private toggleReceiveNotification(event) {
    const {toastError} = this.props
    this.props.updateUser({allow_mail_notifications: event.target.checked})
        .then(res => {
            this.props.fetchInfos().catch(err => toastError(err.msg))
        })
        .catch(err => toastError(err.msg))
  }
}

const state2props = (state: RootState) => ({
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected
});

const dispatch2props = (dispatch: any) => ({
  updateUser: (data) => dispatch(updateAccountInfos(data)),
  fetchInfos: () => dispatch(fetchAccountInfos()),
});

export default compose(
  withI18n,
  withRouter,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(MailNotification)



// WEBPACK FOOTER //
// ./src/page/Consumer/MailNotification/MailNotification.tsx